import { useEffect, useState } from "react";
import DashboardTemplateComponent from "./dashboard-template.component";
import { getDashboardDataApi } from "./dashboard.component.service";

const DashboardComponent = () => {
  const [dashboardData, setDashboardData] = useState();
  const formatRecentLog = (logs) => {
    return logs.map((log, index) => {
      return {
        id: index,
        name: log.admin_name,
        username: log.username,
        days_ago: log.times_ago,
        message: log.log_msg,
      };
    });
  };

  const onLoad = async () => {
    const dashboardResponse = await getDashboardDataApi();
    // console.log({ dashboardResponse });
    if (dashboardResponse.status) {
      const formateData = {
        totalUsers: dashboardResponse.data.total_users.toString(),
        totalBlockedIp: dashboardResponse.data.total_blocked_ip.toString(),
        totalEmailTemplate:
          dashboardResponse.data.total_email_template.toString(),
        totalUserLog: dashboardResponse.data.total_user_log.toString(),
        recentLog: formatRecentLog(dashboardResponse.data.recent_log),
      };
      setDashboardData(formateData);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    dashboardData,
  };

  return (
    <>
      <DashboardTemplateComponent templateModal={templateModal} />
    </>
  );
};

export default DashboardComponent;
